
import Vue from 'vue';
import { Button, Icon } from '@descomplica/vue-components';
import { CourseCertificateModel } from '@/models/studentDocuments';
import { CourseModel } from '@descomplica/dex-models';
import {
  TrackCertificateDownloadButtonClick,
  TrackCertificateDefaultParams,
} from '@/helpers/analytics/types';
import Analytics from '@/helpers/analytics';
import { EVENT_LABELS } from '@/helpers/analytics/labels';
import { downloadImageFromUrl } from '@/helpers/download';
import { ENDPOINTS } from '@/settings/endpoints';

export default Vue.extend({
  name: 'SharedInLinkedinResult',
  components: {
    Button,
    Icon,
  },
  props: {
    success: {
      type: Boolean,
      required: true,
    },
    defaultTrackingParams: {
      type: Object as Vue.PropType<TrackCertificateDefaultParams>,
      required: true,
    },
  },
  computed: {
    currentCourse(): CourseModel {
      return this.$store.getters.currentCourse;
    },
    certificateByCourseId(): CourseCertificateModel | null {
      return this.$store.getters.certificateByCourseId(this.currentCourse.id);
    },
  },
  methods: {
    async downloadImage(): Promise<void> {
      if (!this.certificateByCourseId) return;

      Analytics.trackEvent<TrackCertificateDownloadButtonClick>(
        EVENT_LABELS.postgradStudentDocumentsCertificateDownload,
        {
          ...this.defaultTrackingParams,
          file_type: 'social',
          is_certificate_sharing_result_step: true,
        },
      );

      try {
        await downloadImageFromUrl({
          imageUrl: this.certificateByCourseId?.socialVersionImageUrl,
          fileName: `Certificado de Conclusão - ${this.currentCourse.name}`,
        });
      } catch (err) {
        Analytics.trackEvent<TrackCertificateDownloadButtonClick>(
          EVENT_LABELS.postgradStudentCertificateDownloadError,
          {
            ...this.defaultTrackingParams,
            is_certificate_sharing_result_step: true,
            file_type: 'social',
          },
        );
      }
    },
    openLinkedin(): void {
      window.open(ENDPOINTS.linkedin, '_blank');
      Analytics.trackEvent(EVENT_LABELS.buttonClicked, {
        ...this.defaultTrackingParams,
        in_redirect_to_linkedin: true,
      });
    },
    close(): void {
      this.$emit('onClose');
    },
  },
});
